import React from 'react';

export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
        <div className="prose prose-sm max-w-none">
          {/* Privacy Policy content goes here */}
          <p className="text-gray-600">Last updated: November 06, 2024</p>
          
          <div className="mt-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. WHAT INFORMATION DO WE COLLECT?</h2>
            <p className="text-gray-600 mb-4">
              We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Personal Information You Disclose to Us</h3>
            <p className="text-gray-600 mb-4">
              The personal information we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Names</li>
              <li>Email addresses</li>
            </ul>
          </div>

          {/* Add more sections as needed */}
          
          <div className="mt-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-600">
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <div className="mt-2 text-gray-600">
              <p>The Art of Online Marketing</p>
              <p>17772 Irvine Blvd unit 102A</p>
              <p>Tustin, CA 92780</p>
              <p>United States</p>
              <p>Email: info@artofonline.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}